import { h, Component } from 'preact';
import FieldAdapter from '../adapters/field.adapter';
import { newRelicJSError } from "../analytics/new_relic_helper";

// props: agentnumber - used to fetch the ensemble information
export default class NmEnsemble extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ensemble: {},
            isLoading: false
        };
    }

    componentWillMount() {
        this.setState({ isLoading: true });

        FieldAdapter
            .getEnsembleByAgentNumber(this.props.agentnumber)
            .then(data => {
                this.setState({ ensemble: data }, () => {
                    this.setState({ isLoading: false });
                });
            }).catch(err => {
                const error = "An error occurred while fetching ensemble.";
                newRelicJSError(error);
                console.error(error);
            });
    }

    render() {
        if (!this.state.isLoading &&
            this.state.ensemble.ensembleName &&
            this.state.ensemble.ensembleSlug) {
            return (
                <h4 className="nm-rep-card--ensemble" >
                    <a href={`/group/${this.state.ensemble.ensembleSlug}/`}>{this.state.ensemble.ensembleName}</a>
                </h4>
            );
        }
    }
}